var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page"},[_c('AboutPage'),_c('div',{staticClass:"hairline"}),_c('TechPage'),_c('div',{staticClass:"hairline"}),_c('ProjectsPage'),_c('div',{staticClass:"hairline"}),_c('CareerPage'),_c('div',{staticClass:"hairline"}),_c('ProfilePage'),_c('div',{staticClass:"hairline"}),_c('ContactPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }